const CUSTOM_BUTTON_ID = 'custom-gladly-chat-button';
const HAS_AUTHENTICATED = 'gladly-has-authenticated';
const SHOW_CUSTOM_BUTTON = 'gladly-show';
const SHOW_UNREAD_DOT = 'gladly-unread';

export default {
  CUSTOM_BUTTON_ID,
  HAS_AUTHENTICATED,
  SHOW_CUSTOM_BUTTON,
  SHOW_UNREAD_DOT,
};
